import {fetchData,getAccessControlInfo, getAccessScope, baseUrl} from './webAPIBase';
import log from '../helpers/logger';

export function GetBlogList(topN, StartFr, TagId, accessScope){
    return fetchData(baseUrl+'/CmnBlogWs.asmx/GetBlogList'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    TopN: topN,
                    StartFr: StartFr,
                    TagId: TagId
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function GetBlogById(blogId, accessScope){
    return fetchData(baseUrl+'/CmnBlogWs.asmx/GetBlogById'
        ,{
            requestOptions: {
                body: JSON.stringify({
                    BlogId: blogId
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function GetBlogTagList(accessScope){
    return fetchData(baseUrl+'/CmnBlogWs.asmx/GetBlogTagList'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}

export function GetBlogAboutUs(accessScope){
    return fetchData(baseUrl+'/CmnBlogWs.asmx/GetBlogAboutUs'
        ,{
            requestOptions: {
                body: JSON.stringify({
                }),
            },
            ...(getAccessControlInfo()),
            ...(accessScope)
        }
    )
}


// WEBPACK FOOTER //
// ./src/services/CmnBlogService.js